<ejs-dialog
  target=".dialogs"
  class="simple-dialog"
  [visible]="visible()"
  [animationSettings]="dialogService.getAnimationSettings()"
  [resizeHandles]="dialogService.getResizeHandleDirection()"
  [position]="dialogService.getPosition()"
  [isModal]="true"
  [allowDragging]="false"
  [width]="'40%'"
  [height]="'60vh'"
  [zIndex]="999"
  [showCloseIcon]="true"
  (close)="close()">
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline [title]="('HOMEAVAILABLELINKS' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="d-flex flex-column h-100 p-3" [attr.aria-busy]="loading()">
      <app-form-input
        [type]="'search'"
        [placeholder]="('SEARCHFORLINK' | translate)"
        [iconFront]="'search'"
        [iconBack]="'close'"
        [iconClickType]="'back'"
        [fCN]="'searchString'"
        [fG]="homeLinksForm"
        (iconBackClick)="resetList()">
      </app-form-input>

      @if (loading()) {
        <div class="quick-links-state text-muted d-flex align-items-center gap-2" aria-live="polite">
          <span class="spinner-border spinner-border-sm"></span>
          <span>{{ 'LOADING' | translate }}</span>
        </div>
      } @else if (displayLinks().length === 0) {
        <app-headline [title]="('HOMENOLINKSFOUND' | translate)" [type]="'h6'" [class]="'text-center text-secondary'"></app-headline>
      } @else {
        <div
          class="home-links-dialog-list custom-scrollbar overflow-y-auto"
          tabindex="0"
          [attr.aria-label]="('HOMEAVAILABLELINKS' | translate)">
          <app-home-links
            [links]="displayLinks()"
            [variant]="'quick-nav'"
            [page]="linksPage()"
            [maxPerPage]="displayLinks().length || 1"
            [showPagination]="false"
            (linkClick)="onLinkClick($event)">
          </app-home-links>
        </div>
      }
    </div>
  </ng-template>
</ejs-dialog>
